"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReceiptProof = exports.buildMerklePatriciaProof = exports.getReceiptBytes = void 0;
var merkle_patricia_tree_1 = require("merkle-patricia-tree");
var bytes_1 = require("@ethersproject/bytes");
var rlp_1 = require("@ethersproject/rlp");
var ethereumjs_util_1 = require("ethereumjs-util");
var solidity_1 = require("@ethersproject/solidity");
var bignumber_1 = require("@ethersproject/bignumber");
var blocks_1 = require("../utils/blocks");
var buffer_1 = require("../utils/buffer");
// getStateSyncTxHash returns block's tx hash for state-sync receipt
// Bor blockchain includes extra receipt/tx for state-sync logs,
// but it is not included in transactionRoot or receiptRoot.
// So, while calculating proof, we have to exclude them.
//
// This is derived from block's hash and number
// state-sync tx hash = keccak256("matic-bor-receipt-" + block.number + block.hash)
var getStateSyncTxHash = function (blockNumber, blockHash) {
    return solidity_1.keccak256(["string", "bytes8", "bytes32"], [
        "matic-bor-receipt-",
        bytes_1.hexZeroPad(bignumber_1.BigNumber.from(blockNumber).toHexString(), 8),
        blockHash,
    ]);
};
exports.getReceiptBytes = function (receipt) {
    return rlp_1.encode([
        // eslint-disable-next-line no-nested-ternary
        receipt.status !== undefined && receipt.status !== null ? (receipt.status ? "0x01" : "0x") : receipt.root,
        bytes_1.hexlify(receipt.cumulativeGasUsed),
        receipt.logsBloom,
        // encoded log array
        receipt.logs.map(function (l) {
            // [address, [topics array], data]
            return [l.address, l.topics, l.data];
        }),
    ]);
};
var buildReceiptTrie = function (receipts, blockNumber, blockHash) { return __awaiter(void 0, void 0, void 0, function () {
    var receiptsTrie, stateSyncHash, i, receipt, key, rawReceipt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                receiptsTrie = new merkle_patricia_tree_1.BaseTrie();
                stateSyncHash = getStateSyncTxHash(blockNumber, blockHash);
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < receipts.length)) return [3 /*break*/, 4];
                receipt = receipts[i];
                if (!(receipt.transactionHash !== stateSyncHash)) return [3 /*break*/, 3];
                key = ethereumjs_util_1.rlp.encode(receipt.transactionIndex);
                rawReceipt = exports.getReceiptBytes(receipt);
                // eslint-disable-next-line no-await-in-loop
                return [4 /*yield*/, receiptsTrie.put(key, buffer_1.hexToBuffer(rawReceipt))];
            case 2:
                // eslint-disable-next-line no-await-in-loop
                _a.sent();
                _a.label = 3;
            case 3:
                i += 1;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, receiptsTrie];
        }
    });
}); };
exports.buildMerklePatriciaProof = function (receipt, receipts, blockNumber, blockHash) { return __awaiter(void 0, void 0, void 0, function () {
    var receiptsTrie, key, proof;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, buildReceiptTrie(receipts, blockNumber, blockHash)];
            case 1:
                receiptsTrie = _a.sent();
                key = ethereumjs_util_1.rlp.encode(receipt.transactionIndex);
                return [4 /*yield*/, merkle_patricia_tree_1.BaseTrie.createProof(receiptsTrie, key)];
            case 2:
                proof = _a.sent();
                return [2 /*return*/, {
                        parentNodes: proof.map(ethereumjs_util_1.bufferToHex),
                        root: ethereumjs_util_1.bufferToHex(receiptsTrie.root),
                        path: bytes_1.hexConcat(["0x00", ethereumjs_util_1.bufferToHex(key)]),
                    }];
        }
    });
}); };
exports.buildReceiptProof = function (maticChainProvider, burnTxHash) { return __awaiter(void 0, void 0, void 0, function () {
    var receipt, burnTxBlock, receipts, receiptProof;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, maticChainProvider.getTransactionReceipt(burnTxHash)];
            case 1:
                receipt = _a.sent();
                return [4 /*yield*/, blocks_1.getFullBlockByHash(maticChainProvider, receipt.blockHash)];
            case 2:
                burnTxBlock = _a.sent();
                return [4 /*yield*/, Promise.all(burnTxBlock.transactions.map(function (tx) { return maticChainProvider.getTransactionReceipt(tx); }))];
            case 3:
                receipts = _a.sent();
                return [4 /*yield*/, exports.buildMerklePatriciaProof(receipt, receipts, burnTxBlock.number, burnTxBlock.hash)];
            case 4:
                receiptProof = _a.sent();
                return [2 /*return*/, {
                        receipt: receipt,
                        receiptProof: receiptProof,
                        receiptsRoot: burnTxBlock.receiptsRoot,
                    }];
        }
    });
}); };
